import {action, computed, observable, runInAction} from "mobx"
import Player from "../../stores/PlayerStore";
import {getSharedata, unauthenticatedAccess} from "../../utils/awsUtility";
import {TrackPlayStatus} from "../../constants/enums";


class ShareStore extends Player {
    @observable isFetching = false;
    @observable error = null;
    @observable sharedTrackData = null;

    @computed
    get sharedTrack() {
        return this.sharedTrackData;
    }

    @computed
    get fetchError() {
        return this.error;
    }

    @action fetchData = async (shareId) => {
        this.isFetching = true;
        try {
            await unauthenticatedAccess();
            let sharedTrack = await getSharedata(shareId);

            sharedTrack = Object.assign({}, sharedTrack, {
                playStatus: TrackPlayStatus.Stopped,
                trackActionData: [],
            });

            runInAction(async () => {
                if (!sharedTrack.fileId) {
                    this.error = 'Failed to find shared audio...';
                } else {
                    this.sharedTrackData = this.initTrack(sharedTrack);
                    await this.subscribe(this.sharedTrackData, false, true);
                }
                this.isFetching = false;
            })
        } catch (err) {
            runInAction(() => {
                this.isFetching = false;
                this.error = err;
            })
        }
    }
}

const shareStore = new ShareStore();
export default shareStore;

